

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as d3 from 'd3';
import { compose } from 'recompose';

import styles from './Footer.css';
import { isCaribbean, xlt } from '../../utils/utils';
import withViewport from '../../decorators/withViewport';
import withStyles from '../../decorators/withStyles';


class Footer extends Component {

  static propTypes = {
    placeID: PropTypes.string,
    viewport: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {position: "fixed"}
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    const footer = ReactDOM.findDOMNode(this);
    if (footer) {
      ReactDOM.findDOMNode(this).addEventListener('transitionend', this.handleTransitioned.bind(this));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    if (this.state.position === "fixed" && window.scrollY > 20) {
      this.setState({position: "transitioning"});
    } else if (window.scrollY <= 20) {
      this.setState({position: "fixed"});
    }
  }

  handleTransitioned() {
    this.setState({position: "static"});
  }

  setTxContent(el) {
    d3.select(el).attr("tx-content", "block");
  }

  render() {
    // // This is just an example how one can render CSS
    // const { width, height } = this.props.viewport;
    // this.renderCss(`.Footer-viewport:after {content:' ${width}x${height}';}`);

    return (location.pathname === "/search" ? null :
      <footer className={"Footer footer row " + this.state.position}>
        <div className="columns six meta">
          <a href="https://sealevel.climatecentral.org/about">{xlt('About Us')}</a>|
          <a href="https://sealevel.climatecentral.org/about/disclaimer">{xlt('Disclaimer')}</a>|
          <a href="https://www.climatecentral.org/what-we-do/legal#terms_of_use">{xlt('Terms')}</a>|
          <a href="https://www.climatecentral.org/what-we-do/legal#privacy_policy">{xlt('Privacy')}</a>|
          <a href="https://sealevel.climatecentral.org/about/contact">{xlt('Contact')}</a>
        </div>

        <div className="columns six">
          <a className="cc-logo" href="https://www.climatecentral.org/" ref={this.setTxContent}>{xlt('Sea level tools and analysis by')}
            <img src={require("./logo-climate-central-footer-white.png")} alt="Climate Central" id="logo-footer"/>
          </a>
          {(this.props.placeID && isCaribbean(this.props.placeID)) || (location.pathname.startsWith("/caribbean")) ?
          <a className="idb-logo" href="http://www.iadb.org/" target="_blank">
                <img src="/static/idb-logo_white_20.png" alt="Inter-American Development Bank" id="logo-idb"
                     style={{marginLeft: 10}}
                />
          </a>
              : null}
        </div>
      </footer>
    );
  }

}

export default compose(
  withStyles(styles),
  withViewport,
)(Footer);
